import React from "react";

interface ToggleSwitchProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  disabled?: boolean;
  loading?: boolean;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  id,
  checked,
  onChange,
  label,
  disabled = false,
  loading = false,
}) => {
  const handleToggle = () => {
    onChange(!checked);
  };

  return (
    <label
      htmlFor={id}
      className={`flex items-center ${disabled ? "cursor-not-allowed opacity-70" : "cursor-pointer"}`}
    >
        {label && (
          <span className="mr-3 text-gray-700 dark:text-gray-300 font-medium">
            {label}
          </span>
        )}
      <div className="relative">
        <input
          id={id}
          type="checkbox"
          className="sr-only" // Hide the default checkbox
          checked={checked}
          onChange={handleToggle}
          disabled={disabled}
        />
        <div
          className={`block w-10 h-6 rounded-full transition-colors ${
            checked ? "bg-[#776ce6]" : "bg-gray-300 dark:bg-gray-600"
          }`}
        >
          {loading ? (
            <span className="absolute inset-0 flex items-center justify-center">
              <span className="h-3 w-3 animate-spin rounded-full border-2 border-white border-t-transparent" />
            </span>
          ) : (
            <div
              className={`absolute left-1 top-1/2 -translate-y-1/2 bg-white w-4 h-4 rounded-full transition-transform ${
                checked ? "transform translate-x-4" : ""
              }`}
            />
          )}
        </div>
      </div>
    </label>
  );
};

export default ToggleSwitch;
